import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

const POSITION_OPTIONS = [
    { value: 'UPPER_LEFT', label: '左上' },
    { value: 'UPPER_RIGHT', label: '右上' },
    { value: 'LOWER_LEFT', label: '左下' },
    { value: 'LOWER_RIGHT', label: '右下' },
];

defineBlock({
    type: 'gps_location',
    colour: CATEGORIES.gps.color,
    tooltip: 'GPSセンサーから緯度・経度を取得して変数に入れます',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/gps.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('GPS', { fontSize: 15, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('現在地'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: CATEGORIES.gps.color,
                    options: POSITION_OPTIONS,
                },
                { type: 'label', text: 'で取得し、緯度を' },
                {
                    type: 'field',
                    name: 'LAT_VAR',
                    instance: () =>
                        new FieldVariableLabel('lat', {
                            fontWeight: 'normal',
                            varType: 'float',
                            colorOverride: CATEGORIES.variable.color,
                        }),
                },
                { type: 'label', text: 'に、経度を' },
                {
                    type: 'field',
                    name: 'LNG_VAR',
                    instance: () =>
                        new FieldVariableLabel('lng', {
                            fontWeight: 'normal',
                            varType: 'float',
                            colorOverride: CATEGORIES.variable.color,
                        }),
                },
                { type: 'label', text: 'に入れる ' },
            ],
        },
    ],
});
